import App from "./Locator.svelte";

const app = new App({
    target: document.querySelector("#zagg-locator"),
    props: {}
});

export default app;
